import { render, staticRenderFns } from "./MintalMesPrdSmeltingSlagIronEdit.vue?vue&type=template&id=38044912&"
import script from "./MintalMesPrdSmeltingSlagIronEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdSmeltingSlagIronEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports